import type { AllRouteEndpoints } from "../routeTypes";
export const engagementLandingPageTemplatesDuplicateCacheKeys: AllRouteEndpoints[] = [
  "/engagement/landing_page_templates_data",
];
